import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { browserHistory } from 'react-router';
import { Modal } from 'components';
import { IUserLanguage } from 'models/user/userlanguage';
import { ILanguage } from 'models/common';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import renderIcon from 'helpers/renderIcon';
import { CountdownLoader } from 'containers/Notifications/CountdownLoader';

interface IProps {
	/* functions props */
	t?: (key: string) => string;
	userLanguage?: IUserLanguage;
	languageDomainValues?: ILanguage[];
	shopCode?: string;
}

@connect(
	(state: IStore) => ({
		languageDomainValues: state.domainValues.languages,
		userLanguage: state.userLanguage,
	}),
	(dispatch) => ({
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class CreateShopStepApplicationSuccessfull extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { t, shopCode } = this.props;
		const culture = this.props.userLanguage.culture;

		let url = '/home/' + culture.substring(0, 2);
		if (shopCode) {
			url = '/shop/' + shopCode;
		}

		return (
			<Modal size="extraSmall" modalClass="congratulations">
				<div>
					<div className="getStarted">
						<div className="imageGetStarted">{renderIcon('symbol2')}</div>
						<h2 dangerouslySetInnerHTML={{ __html: t('Shop_CreateShop_StepApplicationSuccessfull_Title') }} />
						<p>{t('Shop_CreateShop_StepApplicationSuccessfull_Desc')}</p>
						<CountdownLoader timeoutMs={3000} onFinished={() => browserHistory.push(url)} />
					</div>
				</div>
			</Modal>
		);
	}
}

export { CreateShopStepApplicationSuccessfull };
